import React from 'react';
import { FiSearch } from 'react-icons/fi';

const SearchBox = ({ value, onChange, placeholder = 'Search...' }) => {
  return (
    <div className="search-box">
      <FiSearch className="search-icon" />
      <input
        type="text"
        className="search-input"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};

export default SearchBox;
